import { Toggle } from '@ui/themed';
import type { ReactNode } from 'react';
import { SettingRow } from './setting-row';

export function SettingToggleRow({
  label,
  description,
  checked,
  onChange,
  mono,
  truncate,
  learnMoreUrl,
  disabled,
  helpText,
  replacement,
  nested,
}: {
  label: ReactNode;
  description?: ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  mono?: boolean;
  truncate?: boolean;
  learnMoreUrl?: string;
  disabled?: boolean;
  helpText?: ReactNode;
  /** Rendered instead of the toggle, e.g. a {@link PlanUpgradePrompt}. */
  replacement?: ReactNode;
  nested?: boolean;
}) {
  return (
    <SettingRow
      label={label}
      description={description}
      learnMoreUrl={learnMoreUrl}
      mono={mono}
      truncate={truncate}
      nested={nested}
      control={
        <div className="flex flex-col items-end">
          {replacement ?? <Toggle checked={checked} onChange={onChange} disabled={disabled} />}
          {helpText && (
            <div className="mt-2 flex items-center text-spark-text-secondary text-xs">
              {helpText}
            </div>
          )}
        </div>
      }
    />
  );
}
